import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-gray-900 text-white">
      <div className="flex-grow p-8 max-w-4xl mx-auto w-full">
        <h1 className="text-3xl font-bold mb-4">Política de Privacidad</h1>
        <p className="text-gray-300 mb-4">
          En <strong>PixArtPlay</strong> (en adelante, “el Sitio”), protegemos la privacidad de nuestros usuarios y tratamos los datos personales conforme a la normativa colombiana vigente sobre protección de datos personales.
        </p>
        <h2 className="text-2xl font-semibold mb-3">Información que Recopilamos</h2>
        <p className="text-gray-300 mb-4">
          Podemos recopilar información personal que nos proporcionas directamente (como nombre, correo electrónico) y automáticamente (como datos de uso, cookies, dirección IP) al interactuar con nuestro sitio.
        </p>
        <h2 className="text-2xl font-semibold mb-3">Uso de la Información</h2>
        <p className="text-gray-300 mb-4">
          La información recopilada se utiliza para operar y mejorar el sitio, personalizar la experiencia del usuario, analizar el uso del sitio, mostrar anuncios y contenidos relevantes y cumplir con nuestras obligaciones legales.
        </p>
        <h2 className="text-2xl font-semibold mb-3">Cookies</h2>
        <p className="text-gray-300 mb-4">
          Nuestro sitio utiliza cookies para mejorar la experiencia de navegación, analizar el tráfico del sitio y servir anuncios personalizados. Puedes gestionar tus preferencias de cookies a través de la herramienta de consentimiento de cookies.
        </p>
		<h2 className="text-2xl font-semibold mb-3">Servicios de Terceros</h2>
        <p className="text-gray-300 mb-4">
         Para el funcionamiento del sitio se utilizan servicios tecnológicos de terceros que pueden intervenir en el tratamiento de datos, siempre bajo estándares adecuados de seguridad y confidencialidad.
		</p>
        <h2 className="text-2xl font-semibold mb-3">Derechos del Titular</h2>
        <p className="text-gray-300 mb-4">
         El titular tiene derecho a acceder, rectificar, eliminar o limitar el tratamiento de tus datos personales. Para ejercer estos derechos, las solicitudes pueden realizarse al correo: contacto@pixartplay.com
        </p>
        <h2 className="text-2xl font-semibold mb-3">Cambios en la Política</h2>          
         <p className="text-gray-300 mb-4">
          Esta política puede actualizarse en cualquier momento. Los cambios serán publicados en esta misma página. </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
